// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__WlIyq","rightAdornment":"Header_rightAdornment__1lfAL"};